import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import { useEffect, useState } from "react";
import Loader from "./components/Loader";

// Importing pages
import Homepage from "./pages/Homepage";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Services from "./pages/Services";
import PrivacyPortal from "./pages/PrivacyPortal";
import ApplyForJob from "./pages/ApplyForJob";
import JobAds from './pages/JobAds';



function ScrollToTop() {
  const location = useLocation();
  // Scroll to top when the route changes

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function App() {
  // Simulating loading state or page transition with a timer
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {isLoading && <Loader />}

      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/privacy-policy" element={<PrivacyPortal />} />
        <Route path="/apply-for-job" element={<ApplyForJob />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/job-ads" element={<JobAds />} />
      </Routes>
    </div>
  );
}

export default App;
